export default [
  {
    id: 1,
    title: "Lorem Ipsum",
    icon: null,
    description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
      industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
      1500s, when an unknown printer took a galley of type and scrambled it to make 
      a type specimen book. It has survived not only five centuries, but also the leap
      into electronic typesetting, remaining essentially unchanged. It was popularised 
      in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
      and more recently with desktop publishing software like Aldus PageMaker including 
      versions of Lorem Ipsum.`,
    githubPath: null,
    demoPath: null,
    year: "2018",
    techUsed: "MERN Stack, Gravatar, Redux.js, Semantic-UI, Bootstrap",
  },
  {
    id: 2,
    title: "Lorem Ipsum",
    icon: null,
    description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
      industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
      1500s, when an unknown printer took a galley of type and scrambled it to make 
      a type specimen book. It has survived not only five centuries, but also the leap
      into electronic typesetting, remaining essentially unchanged. It was popularised 
      in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
      and more recently with desktop publishing software like Aldus PageMaker including 
      versions of Lorem Ipsum.`,
    githubPath: null,
    demoPath: null,
    year: "2018",
    techUsed: "MERN Stack, Gravatar, Redux.js, Semantic-UI, Bootstrap",
  },
  {
    id: 3,
    title: "Lorem Ipsum",
    icon: null,
    description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
      industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
      1500s, when an unknown printer took a galley of type and scrambled it to make 
      a type specimen book. It has survived not only five centuries, but also the leap
      into electronic typesetting, remaining essentially unchanged. It was popularised 
      in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
      and more recently with desktop publishing software like Aldus PageMaker including 
      versions of Lorem Ipsum.`,
    githubPath: null,
    demoPath: null,
    year: "2018",
    techUsed: "Vue.js Framework, Firebase and Firestore, Materialize.css",
  },
  {
    id: 4,
    title: "Lorem Ipsum",
    icon: null,
    description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
      industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
      1500s, when an unknown printer took a galley of type and scrambled it to make 
      a type specimen book. It has survived not only five centuries, but also the leap
      into electronic typesetting, remaining essentially unchanged. It was popularised 
      in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
      and more recently with desktop publishing software like Aldus PageMaker including 
      versions of Lorem Ipsum.`,
    githubPath: null,
    demoPath: null,
    year: "2018",
    techUsed: "HTML5, CSS3, Scalable Vector Graphics",
  },
  {
    id: 5,
    title: "Lorem Ipsum",
    icon: null,
    description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
      industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
      1500s, when an unknown printer took a galley of type and scrambled it to make 
      a type specimen book. It has survived not only five centuries, but also the leap
      into electronic typesetting, remaining essentially unchanged. It was popularised 
      in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
      and more recently with desktop publishing software like Aldus PageMaker including 
      versions of Lorem Ipsum.`,
    githubPath: null,
    demoPath: null,
    year: "2018",
    techUsed: "Vuejs, Firebase and Materialize CSS",
  },
  {
    id: 6,
    title: "Lorem Ipsum",
    icon: null,
    description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
      industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
      1500s, when an unknown printer took a galley of type and scrambled it to make 
      a type specimen book. It has survived not only five centuries, but also the leap
      into electronic typesetting, remaining essentially unchanged. It was popularised 
      in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
      and more recently with desktop publishing software like Aldus PageMaker including 
      versions of Lorem Ipsum.`,
    githubPath: null,
    demoPath: null,
    year: "2018",
    techUsed: "React.js, Tachyons.css",
  },
  {
    id: 7,
    title: "Lorem Ipsum",
    icon: null,
    description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
      industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
      1500s, when an unknown printer took a galley of type and scrambled it to make 
      a type specimen book. It has survived not only five centuries, but also the leap
      into electronic typesetting, remaining essentially unchanged. It was popularised 
      in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
      and more recently with desktop publishing software like Aldus PageMaker including 
      versions of Lorem Ipsum.`,
    githubPath: null,
    demoPath: null,
    year: "2017",
    techUsed: "Node.js, Express.js, MongoDB, Handlebars",
  },
  {
    id: 8,
    title: "Lorem Ipsum",
    icon: null,
    description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
      industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
      1500s, when an unknown printer took a galley of type and scrambled it to make 
      a type specimen book. It has survived not only five centuries, but also the leap
      into electronic typesetting, remaining essentially unchanged. It was popularised 
      in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
      and more recently with desktop publishing software like Aldus PageMaker including 
      versions of Lorem Ipsum.`,
    githubPath: null,
    demoPath: null,
    year: "2018",
    techUsed: "Node.js, GraphQL, React Apollo, Prisma",
  },
  {
    id: 9,
    title: "Lorem Ipsum",
    icon: null,
    description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
      industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
      1500s, when an unknown printer took a galley of type and scrambled it to make 
      a type specimen book. It has survived not only five centuries, but also the leap
      into electronic typesetting, remaining essentially unchanged. It was popularised 
      in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
      and more recently with desktop publishing software like Aldus PageMaker including 
      versions of Lorem Ipsum.`,
    githubPath: null,
    demoPath: null,
    year: "2018",
    techUsed: "Node.js, Express.js, CSV-Parser, React.js, React MapBoxGL",
  },
]
